package one.healthium.onboarding.domain.configs

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import one.healthium.onboarding.domain.models.SelectableOption

@Serializable
@SerialName("choice")
data class SelectableScreenConfig(
    @SerialName("title") val title: String? = null,
    @SerialName("subtitle") val subtitle: String? = null,
    @SerialName("cta_title") val ctaTitle: String? = null,
    @SerialName("options") val options: List<SelectableOption> = emptyList(),
    @SerialName("single_choice") val singleChoice: Boolean = true,
    @SerialName("sign_in_enabled") val signInEnabled: Boolean = false,
    @SerialName("additional_selected_text") val additionalSelectedText: String? = null,
) : ScreenConfig